module.exports = __webpack_public_path__ + "media/images/icons/ic-calendar-download-cf9a2e9bfd3b391e7d6bd1bf4285c1dc.svg";